import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {RuleModel} from '../../../../models/api/ruleModel';
import {Banner, BannerTypesEnum} from '../../../common/banners/banner';
import {BannerAction} from '../../../common/banners/bannerAction';
import {BannerIcon} from '../../../common/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../common/banners/bannersContext';
import {BannerText} from '../../../common/banners/bannerText';

/*
 * Props.
 */

interface RuleCreatedBannerProps {
  onViewRule: Handler;
  rule?: RuleModel;
}

/*
 * Component.
 */

export const RuleCreatedBanner: FC<RuleCreatedBannerProps> = ({rule, onViewRule}) => {
  const theme = useUserTheme();
  if (!rule) {
    return null;
  }

  return (
    <Banner
      bannerType={BannerTypesEnum.INLINE}
      color={theme.palette.green.shade40}
      priority={BannerPrioritiesEnum.TRANSIENT}
    >
      <BannerIcon iconName="gearFilledSmall" />
      <BannerText>
        <Trans id="banner-rule-created">Rule created</Trans>
      </BannerText>
      <BannerAction onClick={onViewRule}>
        <Trans id="banner-view-rule">View Rule</Trans>
      </BannerAction>
    </Banner>
  );
};
